function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2_36)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.263 14.232v17.511a5.99 5.99 0 005.993 5.995h23.488a5.99 5.99 0 005.994-5.995v-17.45c-5.07 1.326-11.123 2.096-17.622 2.096-6.6 0-12.738-.794-17.853-2.156zM.005 6.9A7.35 7.35 0 000 7.18v25.642C0 36.778 3.222 40 7.18 40h25.64c3.958 0 7.18-3.222 7.18-7.18V7.18L40 7.033v6.612c-.302.094-.608.186-.917.277v18.309c0 3.776-3.074 6.85-6.85 6.85H7.768a6.86 6.86 0 01-6.85-6.85V13.854c-.31-.092-.615-.186-.917-.282V7.14c0-.08.002-.16.004-.24z",
  fill: "url(#paint0_linear_2_36)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.263 8.248a5.995 5.995 0 015.993-5.994h23.488a5.995 5.995 0 015.994 5.994v23.496a5.99 5.99 0 01-5.994 5.994H8.256a5.99 5.99 0 01-5.994-5.994V8.248zm-1.345-.48v24.464c0 3.776 3.074 6.85 6.85 6.85h24.464c3.776 0 6.85-3.074 6.85-6.85V7.768c0-3.776-3.074-6.85-6.85-6.85H7.768c-3.776 0-6.85 3.074-6.85 6.85z",
  fill: "#8091C1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.148 0H6.776c-.178 0-.353.009-.527.022C2.808.472.122 3.366.005 6.9.153 3.071 3.315 0 7.18 0h25.64c3.91 0 7.101 3.144 7.178 7.034v-.013c-.057-3.526-2.67-6.444-6.064-6.975A6.891 6.891 0 0033.148 0",
  fill: "#D6DDF0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.744 2.254H8.256a5.995 5.995 0 00-5.994 5.994v5.985c5.116 1.362 11.253 2.156 17.854 2.156 6.499 0 12.552-.77 17.621-2.095V8.248a5.995 5.995 0 00-5.994-5.994zM32.82 0H7.18C3.316 0 .153 3.071.005 6.9c-.002.079-.004.159-.004.24v6.432c.305.097.61.192.917.282V7.768c0-3.776 3.074-6.85 6.85-6.85h24.464c3.776 0 6.85 3.074 6.85 6.85v6.155c.306-.09.612-.182.917-.277V7.034C39.92 3.145 36.729 0 32.82 0z",
  fill: "url(#paint1_linear_2_36)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.232.918H7.768c-3.776 0-6.85 3.074-6.85 6.85v6.086c.447.133.895.259 1.345.378V8.248a5.995 5.995 0 015.993-5.994h23.488a5.995 5.995 0 015.993 5.994v6.046c.45-.117.898-.241 1.345-.371V7.768c0-3.776-3.074-6.85-6.85-6.85z",
  fill: "#8D9FCB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.732 10.807h2.565v-5.19h-5.56a6.114 6.114 0 00-6.113 6.114v3.104h-4.386v5.19h4.386v15.978h6.82V20.025h4.852v-5.19h-4.852v-1.74a2.289 2.289 0 012.288-2.288z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2_36",
  x1: "12.973",
  y1: "12.216",
  x2: "29.439",
  y2: "33.93",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#455E9B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#5A70B3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_2_36",
  x1: "18.727",
  y1: "7.852",
  x2: "35.193",
  y2: "29.566",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#697BB0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#7688C2"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2_36"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h40v40H0z"
})))));